module.exports = __webpack_public_path__ + "media/images/emblems/Unterbaech-coat_of_arms-78d56e9817abb396f69a8555a09f5dd5.svg";